<template>
    <div id="TripMarkers">
        <div v-if="segmsOn">
            <l-polyline
                v-for="item in segms"
                :key="item.id"
                :lat-lngs="item.latlngs"
                :color="item.color"
            >
            </l-polyline>
        </div>
        <l-circle-marker
            :lat-lng="circle.center"
            :radius="circle.radius"
            :color="circle.color"
        />
        <l-locatecontrol
                v-if="geoLoc"
                v-bind:fineGeo=fineGeo
        />
        <l-control position="topleft" v-if="segms.length">
            <button @click="lineHndl">
                <font-awesome-icon icon="unlink" size="lg" />
            </button>
        </l-control>
        <l-marker
            v-for="item in markers"
            :key="item.id"
            :lat-lng="item.position"
            :icon="item.icon"
        >
            <l-popup>
                <div @click="showTripPlace(item.id)">
                    {{ item.name }}
                </div>
            </l-popup>
        </l-marker>

        <b-container fluid class = "footer text-center">
            <b-button one-line class="m-1" v-on:click = "$bvModal.show('modalConf')" v-show="app || curUserName==='admin'">
                <font-awesome-icon icon="download" size="lg" :style="{ color: 'white' }" />
            </b-button>
            <a v-b-popover.hover.top="$t('TRIP_DESC') " title="">
                <b-button one-line class="m-1" v-on:click = "showTrip()">{{ tripName }}</b-button>
            </a>
            <a v-b-popover.hover.top="$t('TRIP_PLACES') " title="" v-show="tripName">
                <b-button one-line class="m-1" v-on:click = "showTripPlacesList()" >
                    <font-awesome-icon icon="folder-open" size="lg" :style="{ color: 'white' }" />
                </b-button>
            </a>
            <div class="m-1" v-show="itemType=='userMap'">{{ this.userName}}. {{ $t('MAP') }}</div>
            <b-button one-line class="m-1 float-right" v-on:click = "showTripFirstPlaceMarker()">
                <font-awesome-icon icon="angle-right" size="lg"/>
            </b-button>
        </b-container>

        <b-modal id="modalConf">
            <div class="d-block text-center">
                <h4>{{this.$t('DOWNLOAD')}}?</h4>
            </div>
            <template v-slot:modal-footer="{ }">
                <b-button variant="success" @click="download()">{{$t('YES')}}</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modalConf')">{{$t('NO')}}</b-button>
            </template>
        </b-modal>

        <b-modal id="modalWait">
            <div class="d-block text-center">
                <h4>{{this.$t('WAITING')}}...</h4>
                <span v-if="progress >= 0">{{ progress }}%</span>
            </div>
            <template v-slot:modal-footer="{ }">
                <b-button variant="danger" @click="$bvModal.hide('modalWait')">{{$t('CANCEL')}}</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import { BContainer, BModal, BButton } from 'bootstrap-vue';
import L from 'leaflet';
import { latLng } from "leaflet";
import { LControl, LMarker, LPopup, LPolyline, LCircleMarker } from "vue2-leaflet";
import MyLocateControl from '@/components/MyLocateControl'
import '@/components/Yandex.js'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "TripMarkers",
  components: {
    LControl, LMarker, LPopup, LPolyline, LCircleMarker,
    'l-locatecontrol': MyLocateControl,
    BContainer, BModal, BButton
  },
  props: {
    map: Object
  },
  data: function() {
    return {
      zoom: 17,
      minZoom: 1,
      maxZoom: 18,
      center: latLng(55.75209, 37.61753),
      bounds: [],
      position: latLng(0, 0),
      showControl: true,
      placeName: '',
      firstPlaceName: '',
      firstPlaceUserName: '',
      userName: '',
      tripName: '',
      itemType: '',
      published: true,
      m: [],
      s: [],
      markers: [],
      segms: [],
      circle: {},
      left: '',
      segmsOn: true,
      app: false,
      geoLoc: false,
      fineGeo: false,
      trip: {},
      curUserName: '',
      wasSaved: false,
      progress: 0
    };
  },
  mounted() {
    this.app = this.$store.state.app;
    /* eslint-disable */
    if (!this.app) {
        this.geoLoc = true;
        this.fineGeo = true;
    }
    else if (typeof AndroidInterface!='undefined') {
        this.fineGeo = AndroidInterface.fineGeoPermitted();
        this.geoLoc = this.fineGeo || AndroidInterface.coarseGeoPermitted();
     }
    /* eslint-enable */
    this.curUserName = this.$store.state.curUserName;
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    this.tripName = this.$rmEncHyp(this.$route.params.itemName);
    this.getTripMarkers();


  },
  methods: {
    lineHndl() {
        this.segmsOn = !this.segmsOn;
    },
    async getTripMarkers() {
        try {
            const response = await this.$http.get('/getTripMarkers', {
                params: {
                    tripName: this.tripName,
                    userName: this.userName,
                    aroundPlace: false
                }
            });
            this.m = response.data.marks;
            if(!this.m.length) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.showTrip();
                return;
            }
            this.s = response.data.segms;
            this.showTripMarkers();
            this.showTripSegms();
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('TripMarkers: getTripMarkers() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async showTripMarkers() {
        let minLat = 90.0; let minLng = 180.0; let maxLat = -90.0; let maxLng = -180.0;
        for(let i = 0; i < this.m.length; i++) {
            let item = {
                id: i,
                name: this.m[i].markName,
                position: latLng(this.m[i].markLat,this.m[i].markLng),
                icon: L.icon({
                    iconUrl : '/data/markers/'+this.m[i].markType+'.png',
                    iconSize : [35, 41],
                    iconAnchor : [12, 37]
                })
            };
            this.markers.push(item);
            if(this.m[i].markLat < minLat) minLat = this.m[i].markLat;
            if(this.m[i].markLng < minLng) minLng = this.m[i].markLng;
            if(this.m[i].markLat > maxLat) maxLat = this.m[i].markLat;
            if(this.m[i].markLng > maxLng) maxLng = this.m[i].markLng;
            if(this.m[i].isFirstPlaceOfTrip==='true') {
                this.showCircle(i);
                this.firstPlaceName = this.m[i].markName;
                this.firstPlaceUserName = this.m[i].userName;
            }
        }
        if(!this.firstPlaceName) {
            this.firstPlaceName = this.m[0].markName;
            this.firstPlaceUserName = this.m[0].userName;
         }
        this.map.fitBounds( [[minLat, minLng], [maxLat, maxLng]]);
        if(this.map.getZoom() === 1 && this.$mq === 'md') this.map.setZoom(2);
    },
    showCircle(i) {
        this.circle.center = [ this.m[i].markLat, this.m[i].markLng];
        //this.circle.radius = 15*(18-this.zoom);
        this.circle.radius = 15;
        this.circle.color = 'red';
    },
    showTripSegms() {
        for(let i = 0; i < this.s.length; i++) {
            let item = {
                id: i,
                latlngs: [ [this.s[i].placeALat, this.s[i].placeALng], [this.s[i].placeBLat, this.s[i].placeBLng] ],
                color: 'green'
            }
            this.segms.push(item);
        }
    },
    showTripPlace(i) {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.m[i].markName)+'/'+this.$addEncHyp(this.m[i].userName)
        })
    },
    showTripFirstPlaceMarker() {
        this.$router.push({
            path: '/Map/PlaceMarker/'+this.$addEncHyp(this.firstPlaceName)+'/'+this.$addEncHyp(this.firstPlaceUserName)
        })
    },
    showTrip() {
        this.$router.push({
            path: '/Tour/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName)
        })
    },
    showTripPlacesList() {
        this.$router.push({
            path: '/TripPlacesList'+'/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName)
        })
    },
    download() {
        this.$bvModal.hide('modalConf');
        this.$bvModal.show('modalWait');
        if(this.curUserName==='admin') this.$saveTripPlacesTilesToServer(this.m, this.map);
        else this.saveTripToApp();
    },
    async saveTripToApp() {
        let tileKeys= [];
        let visibleKeys = [];
        let deferreds = [];
        let deferred;
        // Saving trip tiles
        visibleKeys = this.$getVisibleTilesKeys(this.map);
        this.$itNum = visibleKeys.length;
        if(!this.wasSaved) this.$itNum++;
        for(let i=0; i<visibleKeys.length; i++) {
            try {
                deferred = await this.$http.get('/getTile', {
                    params: {
                        "key": visibleKeys[i]
                    }
                });
                if(!deferred.data.data) tileKeys.push(visibleKeys[i]);
                else {
                    // Tile is found at itsmap server
                    //alert("to json");
                    let json = {};
                    json['key'] = deferred.data.key;
                    json['data'] = deferred.data.data;
                    json['type'] = "trips";
                    json['src'] = "tsw";
                    json['itemName'] = this.tripName;
                    json['userName'] = this.userName;
                    let data = JSON.stringify(json);
                    //console.log(data);
                    /* eslint-disable */
                    if(typeof AndroidInterface!='undefined') AndroidInterface.loadTile(data);
                    /* eslint-enable */
                    this.$itNum--;
                    this.$updateJC();
                }
            }
            catch(error) {
                if(typeof error.response === 'undefined') this.$serveErr('TripMarkers: saveTripToApp() /geTile'+error.message);
                else this.$showErr(error.response.data, error.response.status);
            }
            deferreds.push(deferred);
        }
        if(tileKeys.length>0) {
            this.$saveTiles(tileKeys, "trips", this.tripName, this.userName);
        }

        // Saving trip description
        if(!this.wasSaved && this.curUserName!='admin') {
            try {
                const response = await this.$http.get('/getDesc', {
                    params: {
                        itemName: this.tripName,
                        userName: this.userName,
                        itemType: 'trips'
                    }
                });
                let item = response.data;
                let json = {};
                json['tripName'] = this.tripName;
                json['userName'] = this.userName;
                json['zoom'] = this.map.getZoom;
                json['cntLat'] = this.map.getCenter().lat;
                json['cntLng'] = this.map.getCenter().lng;
                json['desc'] = item.desc;
                json['audio'] = item.audio;
                json['firstPlaceName'] = this.trip.firstPlaceName;
                let data = JSON.stringify(json);
                /* eslint-disable */
                if(typeof AndroidInterface!='undefined') AndroidInterface.loadTrip(data);
                /* eslint-enable */
                //wasSaved = true;
                this.$itNum--;
                this.$updateJC();
            }
            catch(error) {
                if(typeof error.response === 'undefined') this.$serveErr('TripMarkers: saveTripToApp() /geDesc'+error.message);
                else this.$showErr(error.response.data, error.response.status);
            }
        }

        // Saving places
        if(!this.wasSaved) {
            this.$itNum = this.$itNum + this.m.length;
            for (let j=0; j<this.m.length; j++) {
                let lat = this.m[j]["markLat"];
                let lng = this.m[j]["markLng"];
                let zoom = this.m[j]["markZoom"];
                let placeName = this.m[j]["markName"];
                let uName = this.m[j]["userName"];
                this.savePlaceToApp(uName, placeName, lat, lng, zoom);
            }
            this.wasSaved = true;
        }
    },
    async savePlaceToApp(uName, placeName, lat, lng, zoom) {
        //let svTripName = this.tripName;
        let tileKeys = [];
        let aroundKeys = [];
        let deferreds = [];
        let deferred;
        this.$pushKeysAroundPlace(lat, lng, zoom, aroundKeys);
        this.$itNum = this.$itNum + aroundKeys.length;
        //if(!this.wasSaved) this.$itNum++;
        this.$itMax = this.$itNum;
        for(let i=0; i<aroundKeys.length; i++) {
            try {
                deferred = await this.$http.get('/getTile', {
                    params: {
                        "key": aroundKeys[i],
                    }
                });
                if(!deferred.data.data) tileKeys.push(aroundKeys[i]);
                else {
                    //alert("to json");
                    let json = {};
                    json['key'] = deferred.data.key;
                    json['data'] = deferred.data.data;
                    json['type'] = "places";
                    json['src'] = "tsw";
                    json['itemName'] = placeName;
                    json['userName'] = uName;
                    let data = JSON.stringify(json);
                    //console.log(data);
                    /* eslint-disable */
                    if(typeof AndroidInterface!='undefined') AndroidInterface.loadTile(data);
                    /* eslint-enable */
                    this.$itNum--;
                    this.$updateJC();
                }
            }
            catch(error) {
                if(typeof error.response === 'undefined') this.$serveErr('TripMarkers: savePlaceToApp() /getTile'+error.message);
                else this.$showErr(error.response.data, error.response.status);
            }
            deferreds.push(deferred);
        }

        if(tileKeys.length>0) {
            this.$saveTiles(tileKeys, "places", placeName, uName);
        }

        //if(!this.wasSaved && this.curUserName!='admin')
        // Save place
        try {
            //console.log("***", placeName, uName);
            const response = await this.$http.get('/getDesc', {
                params: {
                    userName: uName,
                    itemName: placeName,
                    itemType: 'places'
                }
            });
            let item = response.data;
            var json = {};
            json['placeName'] = placeName;
            json['userName'] = uName;
            // ***
            json['tripAuthor'] = this.userName;
            // ***
            json['tripName'] = this.tripName;
            json['placeLat'] = lat;
            json['placeLng'] = lng;
            json['placeZoom'] = zoom;
            json['desc'] = item.desc;
            json['audio'] = item.audio;
            json['isFirst'] = "false";
            let data = JSON.stringify(json);
            /* eslint-disable */
            if( (typeof AndroidInterface) != 'undefined') AndroidInterface.loadPlace(data);
            /* eslint-enable */
            this.wasSaved = true;
            this.$itNum--;
            this.$updateJC();
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('TripMarkers: savePlaceToApp() /getDesc'+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
    '$store.state.progress': function() {
        this.progress = this.$store.state.progress
        //console.log("progress "+this.progress);
        if(this.$itNum<=0) {
            this.$bvModal.hide('modalWait');
            this.$showMsg(this.$t('DONE'));
        }
    }
  }
};
</script>

<style >
</style>